import React from 'react';
import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { Typography, makeStyles, createStyles, Theme } from "@material-ui/core";
import ReactLoading from 'react-loading';
import { useHistory } from 'react-router-dom';
import { InfoCliente } from '../../../interfaces';
import { Button } from '../../../../../themes/components/Button';
import { useModals } from '../../../../../contexts/Modals';
import { useClientes } from '../../../../../contexts/Clientes';
import { mascaraTelefones } from '../../../../../util/fieldMasks';

interface propsModalDetalheCliente {
    codCli: string;
    showModal: boolean;
    setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: '97%',
            marginLeft: '1em'
        },
    }),
);

const emptPed: InfoCliente = {
    "apecli": "",
    "baicli": "",
    "blocre": "",
    "cepcli": "",
    "cgccpf": "",
    "cidcli": "",
    "codcli": "",
    "codgre": "",
    "codram": "",
    "codcpg": "",
    "descpg": "",
    "contato": [
        {
            "datnas": "",
            "foncto": "",
            "intcto": "",
            "nomcto": "",
        },
        {
            "datnas": "",
            "foncto": "",
            "intcto": "",
            "nomcto": "",
        }
    ],
    "cplend": "",
    "desram": "",
    "endcli": "",
    "foncl1": "",
    "foncl2": "",
    "insest": "",
    "intnet": "",
    "nomcli": "",
    "nomgre": "",
    "numend": "",
    "referencia": [
        {
            "cgcref": "",
            "fonref": "",
            "nomref": "",
        },
        {
            "cgcref": "",
            "fonref": "",
            "nomref": "",
        },
        {
            "cgcref": "",
            "fonref": "",
            "nomref": "",
        }
    ],
    "sigufs": "",
    "sitcli": "",
    "tipcli": ""
}

export function ModalDetalheCliente(props: propsModalDetalheCliente) {
    let history = useHistory();
    const { consultarInfoCliente } = useClientes();
    const { mostrarInfoOK } = useModals();
    const [dadosCliente, setDadosCliente] = useState<InfoCliente>();
    const [loading, setLoading] = useState<boolean>(false);
    const classes = useStyles();

    useEffect(() => {
        async function getDadosCliente() {
            await consultarInfoCliente(props.codCli, history)
                .then(res => {
                    setDadosCliente(res);
                    setLoading(false);
                })
                .catch(err => {
                    console.log(err);
                    setLoading(false);
                })
        }
        setDadosCliente(emptPed);
        if (props.showModal === true) {
            setLoading(true);
            if (props.codCli !== "") {
                getDadosCliente();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.showModal]);


    async function handleCriarPedido() {
        mostrarInfoOK("Função em manutenção!", "Atualização em breve!");
        /*
        history.push({
            pathname: `${process.env.PUBLIC_URL}/pedidos/novo`,
            state: { 
                from: '/pedidos/consultar/modal', 
                Pedido: dadosPedido
            }
        });
        */
    }

    const field = (label: string, value: string | undefined) => {
        return (
            <div className="cabecalho-detalhe-item">
                <Typography className="cabecalho-detalhe-label">{label}</Typography>
                <Typography className="cabecalho-detalhe-value">{value !== undefined && value !== "." ? value : ""}</Typography>
            </div>
        )
    }

    return (
        <Modal
            show={props.showModal}
            onHide={() => [props.setShowModal(false)]}
            dialogClassName="modal-90w"
            animation={true}
            centered={true}
            size='xl'
        >
            {props.showModal === true &&
                <>
                    <Modal.Header closeButton className="modal-header-detalhe-pedido">
                        <Modal.Title className="detalhe-pedido-titulo-modal">
                            {loading ? <ReactLoading type={"bars"} color={"white"} height={30} width={50} className="detalhe-pedido-titulo-loading" /> :
                                <Typography className="detalhe-pedido-texto-titulo">Detalhes do Cliente {dadosCliente?.codcli + " - " + dadosCliente?.nomcli}</Typography>
                            }
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {loading ? <></> :
                            <div style={{ overflowX: 'scroll' }}>
                                <div className={classes.root}>
                                    <div className="cabecalho-detalhe">
                                        <Typography className="cabecalho-detalhe-form-title">Informações do Cliente</Typography>
                                        <div className="cabecalho-detalhe-form-row">
                                            <div className="cabecalho-detalhe-form-column" >
                                                {field("Razão Social:", dadosCliente?.nomcli)}
                                                {field("Nome Fantasia:", dadosCliente?.apecli)}
                                                {field("Tipo Cliente:", dadosCliente?.tipcli === "F" ? "Pessoa Física" : "Pessoa Jurídica")}
                                                {field("CPF/CNPJ:", dadosCliente?.cgccpf)}
                                                {field("E-mail:", dadosCliente?.intnet)}
                                                {field("Telefone 1:", mascaraTelefones(dadosCliente?.foncl1))}
                                                {field("Telefone 2:", mascaraTelefones(dadosCliente?.foncl2))}
                                            </div>
                                            <div className="cabecalho-detalhe-form-column">
                                                {field("Inscrição Estadual:", dadosCliente?.insest)}
                                                {field("Ramo de Atividade:", dadosCliente?.codram + " - " + dadosCliente?.desram)}
                                                {field("Grupo Cliente:", dadosCliente?.codgre !== "0" ? dadosCliente?.codgre + " - " + dadosCliente?.nomgre : "")}
                                                {field("Condição de Pagamento:", dadosCliente?.descpg)}
                                                {field("Bloqueio de Crédito:", dadosCliente?.blocre)}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="cabecalho-detalhe">
                                        <Typography className="cabecalho-detalhe-form-title">Endereço</Typography>
                                        <div className="cabecalho-detalhe-form-row">
                                            <div className="cabecalho-detalhe-form-column">
                                                {field("Endereço:", dadosCliente?.endcli)}
                                                {field("Número:", dadosCliente?.numend)}
                                                {field("Complemento:", dadosCliente?.cplend)}
                                                {field("CEP:", dadosCliente?.cepcli)}
                                            </div>
                                            <div className="cabecalho-detalhe-form-column">
                                                {field("Bairro:", dadosCliente?.baicli)}
                                                {field("Cidade:", dadosCliente?.cidcli)}
                                                {field("Estado:", dadosCliente?.sigufs)}
                                            </div>
                                        </div>
                                    </div>
                                    {dadosCliente?.cobranca !== undefined ?
                                        <div className="cabecalho-detalhe">
                                            <Typography className="cabecalho-detalhe-form-title">Endereço de Cobrança</Typography>
                                            <div className="cabecalho-detalhe-form-row">
                                                <div className="cabecalho-detalhe-form-column">
                                                    {field("Endereço:", dadosCliente?.cobranca.endcob)}
                                                    {field("Número:", dadosCliente?.cobranca.nencob)}
                                                    {field("Complemento:", dadosCliente?.cobranca.cplcob)}
                                                    {field("CEP:", dadosCliente?.cobranca.cepcob)}
                                                </div>
                                                <div className="cabecalho-detalhe-form-column">
                                                    {field("Bairro:", dadosCliente?.cobranca.baicob)}
                                                    {field("Cidade:", dadosCliente?.cobranca.cidcob)}
                                                    {field("Estado:", dadosCliente?.cobranca.estcob)}
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <></>
                                    }
                                    <div className="cabecalho-detalhe">
                                        <Typography className="cabecalho-detalhe-form-title">Contatos</Typography>
                                        <div className="cabecalho-detalhe-form-row">
                                            {dadosCliente?.contato !== undefined && (dadosCliente?.contato instanceof Array ? dadosCliente?.contato : [dadosCliente?.contato]).map((element: any) => (
                                                <div className="cabecalho-detalhe-form-column">
                                                    {field("Nome:", element.nomcto)}
                                                    {field("E-mail:", element.intcto)}
                                                    {field("Telefone:", mascaraTelefones(element.foncto))}
                                                    {field("Aniversário:", element.datnas)}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    <div className="cabecalho-detalhe">
                                        <Typography className="cabecalho-detalhe-form-title">Referências</Typography>

                                        {dadosCliente?.referencia !== undefined && (dadosCliente?.referencia instanceof Array ? dadosCliente?.referencia : [dadosCliente?.referencia]).map((element: any) => (
                                            <div className="cabecalho-detalhe-form-row">
                                                <div className="cabecalho-detalhe-form-column">
                                                    {field("Nome:", element.nomref)}
                                                    {field("CPF/CNPJ:", element.cgcref)}
                                                    {field("Telefone:", mascaraTelefones(element.fonref))}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="modal-additens-footer-itens-area">
                                        <div className="modal-additens-footer-info-area">
                                        </div>
                                        <div className="modal-additens-footer-addbotoes-area">
                                            <Button onClick={() => handleCriarPedido()} classBtn={"btn-footer-novo-pedido color-default"}>Criar Pedido</Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </Modal.Body>
                </>
            }
        </Modal>
    );
}